module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Total work done, or in other words, the sum of all block difficulties.\n        ")]), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            Numbers are in trillions (1,000,000,000,000x).\n        ")]), _vm._v(" "), _c('small', [_vm._v("\n            Just for fun, the approximate total number of SHA256 hashes needed to produce the work: " + _vm._s(_vm.hashes) + ".\n            "), _c('br'), _vm._v("\n            Protip: memorize this number to impress your friends and family, they love to hear about it. No joke! ;)            \n        ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-work"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b8e86c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/work.vue
// module id = 538
// module chunks = 1